import React from 'react';
import { View, StyleSheet } from 'react-native';
import { MarketPricingDiagnostics } from '../components/admin/MarketPricingDiagnostics';

export default function AdminMarketDiagnosticsScreen() {
  return (
    <View style={styles.container}>
      <MarketPricingDiagnostics />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f9fafb',
  },
});
